import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_156_jobcard_add: any[] = [
  {
    "componentType": "screenGroup",
    "title": "Jobcard",
    "style": {},
    "childComponents": [
      {
        "componentType": "form",
        "Name": "jobcard_add",
        "columnNumber": "m1 t1 w1",
        "TableName": "service_job_card",
        "Plugins": [{ "type": "api" }],
        "DisplayName": "Jobcard",
        "Workflow": "service",
        "DisableSubmit": true,
        "SubmitActions": [
          {
            "Action": "Navigate",
            "Navigate": "modulev1/vehicleinsummary"
          }
        ],
        "style": {
          "backgroundColor": "#ffffff",
          "direction": "column",
          "padding": 10
        },
        "Fields": [
          {
            "componentType": "group",
            "Label": "",
            "BindValue": "cont_Action",
            "style": {
              "direction": "row",
              "padding": 0,
              "margin": 0,
              "marginBottom": 8
            },
            "childComponents": [
              {
                "componentType": "button",
                "name": "Edit",
                "Label": "Edit",
                "BindValue": "btn_Edit",
                "onPressAction": "edit",
                "ScreenId": "156",
                "ActionType": "Edit",
                "LockBinding": true,
                "Enabled": {
                  "Enable": {
                    "Json_Attribute": "current_state",
                    "values": [
                      "Approved",
                      "QC Rejected"
                    ]
                  },
                  "Mode": [
                    "View"
                  ]
                },
                "style": {
                  "backgroundColor": "var(--primary-green)",
                  "textColor": "#FFFFFF",
                  "padding": 8,
                  "borderRadius": 4,
                  "fontSize": 14
                }
              },
              {
                "componentType": "button",
                "name": "lock",
                "Label": "lock",
                "BindValue": "lock",
                "onPressAction": "unlock",
                "ScreenId": "156",
                "ActionType": "Unlock",
                "LockBinding": true,
                "style": {
                  "backgroundColor": "var(--primary-green)",
                  "textColor": "#FFFFFF",
                  "padding": 8,
                  "marginBottom": 8,
                  "borderRadius": 4,
                  "fontSize": 14
                }
              },
              {
                "componentType": "button",
                "name": "Basic print",
                "Label": "Basic print",
                "BindValue": "btn_Print",
                "onPressAction": "pdf",
                "Settings": "Job_card_pdf",
                "ActionType": "PDF",
                "toolTip": "Basic print",
                "Enabled": {
                  "Mode": [
                    "View"
                  ]
                },
                "style": {
                  "backgroundColor": "var(--primary-green)",
                  "textColor": "#FFFFFF",
                  "padding": 8,
                  "marginBottom": 8,
                  "borderRadius": 4,
                  "fontSize": 14
                }
              },
              {
                "componentType": "button",
                "name": "Complete print",
                "Label": "Complete print",
                "BindValue": "btn_Print_jobcard",
                "onPressAction": "pdf",
                "Settings": "Job_card_pdf_with_rates",
                "ActionType": "PDF",
                "toolTip": "Complete print",
                "Enabled": {
                  "Mode": [
                    "View"
                  ]
                },
                "style": {
                  "backgroundColor": "var(--primary-green)",
                  "textColor": "#FFFFFF",
                  "padding": 8,
                  "marginBottom": 8,
                  "borderRadius": 4,
                  "fontSize": 14
                }
              },
              {
                "componentType": "button",
                "name": "View Summary",
                "Label": "View Summary",
                "BindValue": "btn_ViewSummary",
                "onPressAction": "html_drawer",
                "Settings": "job_card_summary_details",
                "ActionType": "HTML_DRAWER",
                "toolTip": "View Summary",
                "style": {
                  "backgroundColor": "var(--primary-green)",
                  "textColor": "#FFFFFF",
                  "padding": 8,
                  "marginBottom": 8,
                  "borderRadius": 4,
                  "fontSize": 14
                }
              }
            ]
          },
          {
            "componentType": "fieldGroup",
            "Label": "Jobcard details",
            "BindValue": "con_jobcard_details",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "IncludeLabel": true,
                "Label": "Job No.",
                "PlaceHolder": "Will be auto generated...",
                "IsMandatory": false,
                "BindValue": "txt_jobno",
                "Json_Attribute": "jobcard_no",
                "componentType": "textField",
                "showInSummary": false,
                "AutoPopulate": true,
                "IsReadOnly": true,
                "AutoPopulate_format": "JOB_[******]",
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Job date",
                "PlaceHolder": "job_date",
                "IsMandatory": true,
                "BindValue": "txt_jobdate",
                "Json_Attribute": "job_date",
                "componentType": "dateField",
                "showInSummary": false,
                "IsVerticalView": true,
                "DefaultToday": true
              },
              {
                "IncludeLabel": true,
                "Label": "Estimation No.",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "parentid",
                "Json_Attribute": "parent_id",
                "componentType": "searchableDropdown",
                "showInSummary": false,
                "IsReadOnly": true,
                "LookupName": "estimation_items",
                "IsVerticalView": true
              },
              {
                "Label": "",
                "BindValue": "veh_details",
                "componentType": "report",
                "IncludeLabel": true,
                "Settings": "Vehicle_details",
                "Parent_Field": "parentid"
              }
            ]
          },
          {
            "componentType": "fieldGroup",
            "Label": "Spare parts",
            "BindValue": "cont_Work_requested",
            "columnNumber": "m1 t1 w1",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "componentType": "subModule",
                "name": "service_spare_req",
                "label": "Spare parts",
                "tableName": "service_spare_req",
                "lookupName": "estimation_Spareparts",
                "parentField": "parentid",
                "BindValue": "sub_Checklist",
                "DisableAddNewRow": true,
                "childControls": [
                  {
                    "IncludeLabel": false,
                    "Label": "test",
                    "PlaceHolder": "",
                    "IsHidden": true,
                    "BindValue": "est_ref_id",
                    "Json_Attribute": "est_ref_id",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Code",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_code",
                    "Json_Attribute": "codeid",
                    "componentType": "searchableDropdown",
                    "showInSummary": false,
                    "LookupName": "product_itemcode",
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Narration",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_narration",
                    "Json_Attribute": "narration",
                    "componentType": "textArea",
                    "showInSummary": false,
                    "IsVerticalView": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Qty",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_qty",
                    "Json_Attribute": "req_qty",
                    "componentType": "textField",
                    "showInSummary": false,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Rate",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_rate",
                    "Json_Attribute": "rate",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_amount",
                    "Json_Attribute": "amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_rate] * [txt_qty]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT%",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_vat",
                    "Json_Attribute": "vat_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "tax_rates",
                    "IncludeNotSet": false,
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_vat_amt",
                    "Json_Attribute": "vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Net amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_net_amt",
                    "Json_Attribute": "net_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] + [txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Department",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_department",
                    "Json_Attribute": "department_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "department",
                    "IsVerticalView": true
                  }
                ],
                "FooterControls": [
                  {
                    "componentType": "textField",
                    "BindValue": "txt_one",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_2",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_3",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_amount",
                    "Json_Attribute": "spare_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_amount]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_4",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "VAT Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_vat_amt",
                    "Json_Attribute": "spare_vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Net Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_net_amount",
                    "Json_Attribute": "spare_net_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_net_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_6",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_10",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_11",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  }
                ]
              }
            ]
          },
          {
            "componentType": "fieldGroup",
            "Label": "Labour /Others",
            "BindValue": "cont_labour_requested",
            "columnNumber": "m1 t1 w1",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "componentType": "subModule",
                "name": "view_jobcard_details",
                "label": "Labour /Others",
                "tableName": "service_labour",
                "lookupName": "estimation_labour",
                "parentField": "parentid",
                "BindValue": "sub_labour",
                "DisableAddNewRow": true,
                "childControls": [
                  {
                    "IncludeLabel": false,
                    "Label": "test",
                    "PlaceHolder": "",
                    "IsHidden": true,
                    "BindValue": "est_ref_id",
                    "Json_Attribute": "est_ref_id",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "code",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_code",
                    "Json_Attribute": "codeid",
                    "componentType": "searchableDropdown",
                    "showInSummary": false,
                    "LookupName": "itemcode",
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Narration",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_narration",
                    "Json_Attribute": "narration",
                    "componentType": "textArea",
                    "showInSummary": false,
                    "IsVerticalView": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Qty",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_qty",
                    "Json_Attribute": "qty",
                    "componentType": "textField",
                    "showInSummary": false,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Rate",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_rate",
                    "Json_Attribute": "rate",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": false,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_amount",
                    "Json_Attribute": "amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_rate] * [txt_qty]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT%",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_vat",
                    "Json_Attribute": "vat_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "tax_rates",
                    "IncludeNotSet": false,
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_vat_amt",
                    "Json_Attribute": "vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Net amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_net_amt",
                    "Json_Attribute": "net_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] +  [txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Department",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_department",
                    "Json_Attribute": "department_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "department",
                    "IsVerticalView": true
                  }
                ],
                "FooterControls": [
                  {
                    "componentType": "textField",
                    "BindValue": "txt_one",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_2",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_3",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_amount",
                    "Json_Attribute": "labour_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_amount]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_4",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "VAT Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_vat_amt",
                    "Json_Attribute": "labour_vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Net Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_net_amount",
                    "Json_Attribute": "labour_net_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_net_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_6",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_10",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_11",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  }
                ]
              }
            ]
          },
          {
            "componentType": "fieldGroup",
            "Label": "Miscellaneous",
            "BindValue": "miss_requested",
            "columnNumber": "m1 t1 w1",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "componentType": "subModule",
                "name": "estimation_miscellaneous",
                "label": "Miscellaneous",
                "tableName": "service_jobcard_miscellaneous",
                "lookupName": "estimation_miscellaneous",
                "parentField": "parentid",
                "BindValue": "estimation_miscellaneous",
                "DisableAddNewRow": true,
                "childControls": [
                  {
                    "IncludeLabel": false,
                    "Label": "test",
                    "PlaceHolder": "",
                    "IsHidden": true,
                    "BindValue": "est_ref_id",
                    "Json_Attribute": "est_ref_id",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Item type",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_item_type",
                    "Json_Attribute": "item_type",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "item_type",
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Item name",
                    "IsMandatory": true,
                    "BindValue": "item_name",
                    "Json_Attribute": "item_name",
                    "componentType": "textField",
                    "showInSummary": true,
                    "IsVerticalView": true,
                    "inputType": "text"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Qty",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_qty",
                    "Json_Attribute": "qty",
                    "componentType": "textField",
                    "showInSummary": false,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Rate",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_rate",
                    "Json_Attribute": "rate",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": false,
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_amount",
                    "Json_Attribute": "amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_rate] * [txt_qty]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT%",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_vat",
                    "Json_Attribute": "vat_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "tax_rates",
                    "IncludeNotSet": false,
                    "IsVerticalView": true
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "VAT amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_vat_amt",
                    "Json_Attribute": "vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Net amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_net_amt",
                    "Json_Attribute": "net_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[txt_amount] + [txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": true,
                    "Label": "Department",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "drp_department",
                    "Json_Attribute": "department_id",
                    "componentType": "selectDropdown",
                    "showInSummary": false,
                    "LookupName": "department",
                    "IsVerticalView": true
                  }
                ],
                "FooterControls": [
                  {
                    "componentType": "textField",
                    "BindValue": "txt_one",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_2",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_4",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_6",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_amount",
                    "Json_Attribute": "miscellaneous_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_amount]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_7",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "VAT Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_vat_amt",
                    "Json_Attribute": "miscellaneous_vat_amt",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_vat_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "IncludeLabel": false,
                    "Label": "Net Amount",
                    "PlaceHolder": "",
                    "IsMandatory": false,
                    "BindValue": "txt_sub_net_amount",
                    "Json_Attribute": "miscellaneous_net_amount",
                    "componentType": "textField",
                    "showInSummary": false,
                    "IsReadOnly": true,
                    "ExpressionV2": "[SUM:txt_net_amt]",
                    "Default_Value": "0",
                    "IsVerticalView": true,
                    "inputType": "number"
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_10",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  },
                  {
                    "componentType": "textField",
                    "BindValue": "txt_11",
                    "IncludeLabel": false,
                    "IsReadOnly": true,
                    "style": {
                      "display": "none"
                    }
                  }
                ]
              }
            ]
          },
          {
            "componentType": "fieldGroup",
            "Label": "Total Summary",
            "BindValue": "cont_total_summary",
            "columnNumber": "m1 t1 w3",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "IncludeLabel": true,
                "Label": "Gross amount",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "total_sub_amount",
                "Json_Attribute": "total_sub_amount",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[(service_spare_req).txt_sub_amount] + [(view_jobcard_details).txt_sub_amount]+[(estimation_miscellaneous).txt_sub_amount]",
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Discount",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_discount",
                "Json_Attribute": "discount",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "BindParent": {
                  "parentid": "discount"
                },
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Total  amount",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "gross_net_amount",
                "Json_Attribute": "gross_net_amount",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[(service_spare_req).txt_sub_net_amount] + [(view_jobcard_details).txt_sub_net_amount]+[(estimation_miscellaneous).txt_sub_net_amount]- [txt_discount]",
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              }
            ]
          }
        ]
      },
      {
        "componentType": "grid",
        "columnNumber": "m1 t2 w1",
        "childComponents": [
          {
            "componentType": "button",
            "name": "Submit",
            "Label": "Submit",
            "BindValue": "btn_submit",
            "onPressAction": "save",
            "ScreenId": "156",
            "ActionType": "Add",
            "Enabled": {
              "Mode": [
                "Edit",
                "Add"
              ]
            },
            "style": {
              "backgroundColor": "var(--primary-green)"
            }
          },
          {
            "componentType": "button",
            "name": "Cancel",
            "Label": "Cancel",
            "BindValue": "btn_cancel",
            "onPressAction": "navigate",
            "Navigate": "modulev1/vehicleinsummary",
            "ActionType": "Navigate",
            "style": {
              "backgroundColor": "var(--secondary-gray)"
            }
          }
        ]
      }
    ]
  }
];
